(ns yardwerkz.capra-client
  "Singleton capra client for the yardwerkz web app.

   Uses a dedicated Sente channel socket at /capra.
   Exposes a `ready` promise that resolves once init! has set up the
   transport, so callers can await initialization before sending RPCs."
  (:require
   [capra.core :as capra]
   [capra.adapters.sente :as capra-sente]
   [taoensso.sente :as sente]
   [lambdaisland.glogi :as log]))

;; Register #rpc/* tag readers at module load time — BEFORE any Sente
;; messages are parsed. Same pattern as yardwerkz.web.temporal for #time/*.
(capra/install-readers!)

(defonce client (atom nil))

;; Resolves when init! has created the client and transport.
;; The Sente transport's retry logic handles sends that arrive before
;; the connection is live, so we only need to gate on init! completing.
(defonce ready (atom (js/Promise.reject (ex-info "Capra client not initialized" {}))))

;; Suppress unhandled rejection on the initial sentinel promise
(.catch @ready (fn [_]))

(defn init!
  "Initialize the capra client with a dedicated Sente connection.
   base-url: the API base URL (e.g. \"http://localhost:4000\")"
  [base-url]
  (let [https? (clojure.string/starts-with? base-url "https")
        {:keys [ch-recv send-fn]}
        (sente/make-channel-socket-client!
         "/capra"
         nil
         {:type     :auto
          :packer   :edn
          :protocol (if https? :https :http)
          :host     (-> base-url
                        (clojure.string/replace #"^https?://" ""))
          :params   {:client-id (str (random-uuid))}})
        transport (capra-sente/make-sente-transport
                   {:send-fn send-fn :ch-recv ch-recv})
        cl        (capra/make-client transport)]
    (reset! client cl)
    (reset! ready (js/Promise.resolve cl))
    (log/info :capra/client-initialized {:base-url base-url})))
